module.exports = {
  market: 'en-US',
  realm: 'US',
  domain: 'weightwatchers.com',
  countryId: '1000',
  vsPath: 'us',
  spiceLocale: 'us',
  vsUrl: 'https://www{env}weightwatchers.com/us',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/us/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.com/',
  currency: '$',
  decimalSeparator: '.',
  thousandSeparator: ',',
  currencyFormat: '$%number ',
  useZipCodeForEligibleOffers: true,
  dateFormat: 'MM/dd/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.com/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.com/v2/login/',
  countryCode: 'US',
  commUlr: 'https://commerce{env}weightwatchers.com/us/en/api/',
  timezone1: 'America/New_York',
  timezone2: '-05:00',
};
